export enum UserDashboardSettingsUrl {
  base = '/user-dashboard-settings',
}
